const actions = {
  CREATE_MEMBER_FILTER: 'CREATE_MEMBER_FILTER',
  CREATE_MEMBER_FILTER_ENDED: 'CREATE_MEMBER_FILTER_ENDED',
  SEARCH_MEMBER_FILTERS: 'SEARCH_MEMBER_FILTERS',
  SEARCH_MEMBER_FILTERS_ENDED: 'SEARCH_MEMBER_FILTERS_ENDED',
  FIND_MEMBER_FILTER: 'FIND_MEMBER_FILTER',
  FIND_MEMBER_FILTER_ENDED: 'FIND_MEMBER_FILTER_ENDED',
  UPDATE_MEMBER_FILTER: 'UPDATE_MEMBER_FILTER',
  UPDATE_MEMBER_FILTER_ENDED: 'UPDATE_MEMBER_FILTER_ENDED',
  DELETE_MEMBER_FILTERS: 'DELETE_MEMBER_FILTERS',
  DELETE_MEMBER_FILTERS_ENDED: 'DELETE_MEMBER_FILTERS_ENDED',
  TRIGGER_MEMBER_FILTERS: 'TRIGGER_MEMBER_FILTERS',
  TRIGGER_MEMBER_FILTERS_ENDED: 'TRIGGER_MEMBER_FILTERS_ENDED',
  GET_MEMBER_FILTER_TRIGGER_RECORD_STATISTICS: 'GET_MEMBER_FILTER_TRIGGER_RECORD_STATISTICS',
  GET_MEMBER_FILTER_TRIGGER_RECORD_STATISTICS_ENDED:
    'GET_MEMBER_FILTER_TRIGGER_RECORD_STATISTICS_ENDED',
  SEARCH_MEMBER_FILTER_TRIGGER_RECORDS: 'SEARCH_MEMBER_FILTER_TRIGGER_RECORDS',
  SEARCH_MEMBER_FILTER_TRIGGER_RECORDS_ENDED: 'SEARCH_MEMBER_FILTER_TRIGGER_RECORDS_ENDED',
};

export default actions;
